import Box from '@mui/material/Box'

const FirstMessageTop = ({operationWordingVerb, pageNameSingular}) => {
  return (
    <Box
      component='span'
      sx={(theme) => ({
        ...theme.typography.p,
        alignItems: 'center',
        color: theme.palette.tertiary.main,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: '0 0 20px 0',
        width: '100%'
      })}
    >
      Are you sure you want to {operationWordingVerb}
      <span>selected {pageNameSingular}(s)?</span>
    </Box>
  )
}

export default FirstMessageTop
